<div class="login">
  <div class="login-side-1">
    <div class="login-center">
      <div class="logo-card">
        <img src="logo_frigelar_portal.png" class="logo-portal" alt="Frigelar">
        <p class="portal-description">Portal Frigelar</p>
      </div>
    </div>
  </div>
  <div class="login-side-2">
      <div *ngIf="loading" class="div-loader"><div class="div-loader-center"><div class="loader"></div></div></div>
      <div class="login-center">
          <div class="login-card" (keyup.enter)="login()">
            <h3 class="login-title">Login</h3>
            <div class="form-group">
              <label for="email">Usuário</label>
              <input type="text" class="form-control form-login" id="email" placeholder="" [(ngModel)]="email">
            </div>
            <div class="form-group">
              <label for="password">Senha</label>
              <div class="form-login">
                <input type="password" class="form-control form-login" id="password" placeholder="" [(ngModel)]="password">
                <a *ngIf="passwordVisible" class="passwordEye" (click)="togglePasswordHide()">
                  <img src="eye.svg">
                </a>
                <a *ngIf="!passwordVisible" class="passwordEye" (click)="togglePasswordHide()">
                  <img src="eye-slash.svg">
                </a>
              </div>
            </div>

            <div id="divError" style="display: none;" class="form-group">
              <div class="divError">Não foi possível autenticar com as informações fornecidas. Utilize suas credenciais de rede.</div>
            </div>

            <div id="divError2" style="display: none;" class="form-group">
              <div class="divError">Ocorreu um erro interno. Contate o suporte</div>
            </div>

            <br>
            <div>
              <button class="btn btn-outline btn-login" (click)="login()">Login</button>
              <button class="btn btn-outline btn-support" (click)="support()">Suporte</button>
            </div>
          </div>
        </div>
  </div>
</div>
